import _define_property from "@swc/helpers/src/_define_property.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { storyblokEditable } from "@cinch-nx/data-storyblok";
import cx from "classnames";
import Image from "next/image";
import styles from "./image-gallery.module.css";
export var ImageGallery = function(blok) {
    var ref;
    var images = blok.images;
    var _alt;
    return /*#__PURE__*/ _jsx("section", _object_spread_props(_object_spread({}, storyblokEditable(blok)), {
        className: styles.galleryGrid,
        children: (ref = images === null || images === void 0 ? void 0 : images.filter(function(image) {
            return image === null || image === void 0 ? void 0 : image.filename;
        })) === null || ref === void 0 ? void 0 : ref.map(function(image, idx) {
            var _obj;
            return /*#__PURE__*/ _jsx("div", {
                className: cx(styles.imageWrapper, styles["image".concat(idx + 1)], (_obj = {}, _define_property(_obj, styles.mobileMargins, idx <= 1), _define_property(_obj, styles.mobileImage, idx <= 2), _define_property(_obj, styles.desktopImage, idx > 2), _obj)),
                children: /*#__PURE__*/ _jsx(Image, {
                    src: image.filename,
                    alt: (_alt = image.alt) !== null && _alt !== void 0 ? _alt : undefined,
                    layout: "fill",
                    objectPosition: "60% center",
                    objectFit: "cover"
                })
            }, image.id);
        })
    }));
};
export default ImageGallery;
